import FileService from "./FileService";
import { Request } from "./HttpService";

export const InterviewAdvanceSearchService = {
  saveFilter(filters, name) {
    let req = {
      name,
      filters
    };
    return Request(`vitae/interviewAdvanceSearch/filter`, "POST", req);
  },
  deleteFilter(filterName) {
    return Request(
      `vitae/interviewAdvanceSearch/filter/${filterName}`,
      "DELETE"
    );
  },
  search(searchObject, pageSize, pageNumber) {
    let url = `vitae/interviewAdvanceSearch/${pageSize}/${pageNumber}`;

    return Request(url, "GET", searchObject);
  },
  getFilters() {
    return Request(`vitae/interviewAdvanceSearch/filter/`, "GET");
  },
  updateFilter(filterName) {
    return Request(`vitae/interviewAdvanceSearch/filter/${filterName}`, "PUT");
  },
  export(searchObject, fileName) {
    FileService.DownloadWithPost(
      `vitae/interviewadvancesearch/export`,

      fileName,
      searchObject
    );
  },
  saveSearch(searchObject) {
  
    return Request(`vitae/interviewAdvanceSearch/schedulesearch`, "POST", searchObject);
  }
};
